var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('path',{attrs:{"data-name":"check","d":"M8.107 10.071l.007-.007-2.107-2.107.707-.707L8.82 9.357 15.178 3l.707.707-6.357 6.357.015.015-.707.707-.015-.015-.007.007z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }